
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 500 300"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#3A75C4","d":"M0 0h500v300H0z"}}),_c('path',{attrs:{"fill":"#CE1126","d":"M0 0h500v225H0z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M0 0h500v150H0z"}}),_c('path',{attrs:{"fill":"#FFC61E","d":"M0 0h500v75H0z"}}),_c('path',{attrs:{"fill":"#3D8E33","d":"M0 300l250-150L0 0v300z"}}),_c('circle',{attrs:{"fill":"#FFF","cx":"85","cy":"150","r":"67.5"}}),_c('circle',{attrs:{"fill":"#3D8E33","cx":"115","cy":"150","r":"67.5"}}),_c('path',{attrs:{"id":"a","fill":"#FFF","d":"M100.01 89.2l7.36 22.588-19.258-13.949h23.776L92.63 111.788l7.38-22.588z"}}),_c('use',{attrs:{"xlink:href":"#a","y":"32.208"}}),_c('use',{attrs:{"xlink:href":"#a","y":"64.417"}}),_c('use',{attrs:{"xlink:href":"#a","y":"96.625"}})])
          )
        }
      }
    